import type { Palette } from '@mui/material/styles';

const LIGHT_BORDER = '#A9AAB6';
const LIGHT_MARK = '#FFFFFF';

export function checkboxIconColors(palette: Palette) {
  const dark = palette.mode === 'dark';

  return {
    dark,
    border: dark ? palette.text.secondary : LIGHT_BORDER,
    mark: dark ? palette.primary.contrastText : LIGHT_MARK,
    fill: (gradientId: string) => (dark ? palette.primary.main : `url(#${gradientId})`),
  };
}
